import {
  Component,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'irembogov-officer-comment',
  templateUrl: './irembogov-officer-comment.component.html',
  styleUrls: ['./irembogov-officer-comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrembogovOfficerCommentComponent implements OnChanges {
  @Input() comment = '';
  @Input() label = 'Officer Comment';

  safeComment: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    this.safeComment = this.sanitizer.bypassSecurityTrustHtml(this.comment); //NOSONAR
  }
}
